import { render, staticRenderFns } from "./report-info.vue?vue&type=template&id=5c36091e&scoped=true&"
import script from "./report-info.vue?vue&type=script&lang=js&"
export * from "./report-info.vue?vue&type=script&lang=js&"
import style0 from "./report-info.vue?vue&type=style&index=0&id=5c36091e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36091e",
  null
  
)

export default component.exports